import React, { useEffect, useState } from "react";

const STORAGE_KEY = "multi-stock-ledger";

function App() {
  const [stocks, setStocks] = useState({});
  const [activeStock, setActiveStock] = useState("");
  const [newStock, setNewStock] = useState("");
  const [editingTradeId, setEditingTradeId] = useState(null);
const [editPrice, setEditPrice] = useState("");
const [editQty, setEditQty] = useState("");


  const [price, setPrice] = useState("");
  const [qty, setQty] = useState("");

  /* ---------- LOAD ---------- */
  useEffect(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved) {
      const data = JSON.parse(saved);
      setStocks(data.stocks || {});
      setActiveStock(data.activeStock || "");
    }
  }, []);

  /* ---------- SAVE ---------- */
  useEffect(() => {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ stocks, activeStock })
    );
  }, [stocks, activeStock]);

  /* ---------- ADD STOCK ---------- */
  const addStock = () => {
    if (!newStock || stocks[newStock]) return;

    setStocks({
      ...stocks,
      [newStock]: {
        trades: [],
        brokeragePercent: 0.2,
        taxPercent: 0.1,
        currentPrice: "",
      },
    });

    setActiveStock(newStock);
    setNewStock("");
  };

  /* ---------- ADD TRADE ---------- */
  const addTrade = () => {
    if (!price || !qty || !activeStock) return;

    const updated = { ...stocks };
    updated[activeStock].trades.push({
      id: Date.now(),
      price: Number(price),
      qty: Number(qty),
    });

    setStocks(updated);
    setPrice("");
    setQty("");
  };

  const stock = stocks[activeStock];

  /* ---------- CALCULATIONS ---------- */
  let totalQty = 0;
  let totalBuy = 0;

  if (stock) {
    stock.trades.forEach((t) => {
      totalQty += t.qty;
      totalBuy += t.price * t.qty;
    });
  }

  const avgPrice = totalQty ? totalBuy / totalQty : 0;
  const sellValue = stock?.currentPrice
    ? stock.currentPrice * totalQty
    : 0;

  const grossProfit = sellValue - totalBuy;

  const brokerage =
    ((totalBuy + sellValue) * (stock?.brokeragePercent || 0)) /
    100;

  const tax =
    grossProfit > 0
      ? (grossProfit * (stock?.taxPercent || 0)) / 100
      : 0;

  const netProfit = grossProfit - brokerage - tax;

  const startEdit = (trade) => {
  setEditingTradeId(trade.id);
  setEditPrice(trade.price);
  setEditQty(trade.qty);
};

const cancelEdit = () => {
  setEditingTradeId(null);
  setEditPrice("");
  setEditQty("");
};

const saveEdit = (tradeId) => {
  const updated = { ...stocks };

  updated[activeStock].trades = updated[activeStock].trades.map((t) =>
    t.id === tradeId
      ? { ...t, price: Number(editPrice), qty: Number(editQty) }
      : t
  );

  setStocks(updated);
  cancelEdit();
};

const deleteTrade = (tradeId) => {
  if (!window.confirm("Delete this trade?")) return;

  const updated = { ...stocks };
  updated[activeStock].trades = updated[activeStock].trades.filter(
    (t) => t.id !== tradeId
  );

  setStocks(updated);
};

const deleteStock = (stockName) => {
  if (!window.confirm(`Delete ${stockName} and all its trades?`)) return;

  const updatedStocks = { ...stocks };
  delete updatedStocks[stockName];

  const remainingStocks = Object.keys(updatedStocks);

  setStocks(updatedStocks);
  setActiveStock(remainingStocks[0] || "");
};




  return (
    <div className="container">
      <h2>📈 Multi-Stock Profit Tracker</h2>

      {/* STOCK TABS */}
    <div className="tabs">
  {Object.keys(stocks).map((s) => (
    <div key={s} className="tab-wrapper">
      <button
        className={s === activeStock ? "active-tab" : ""}
        onClick={() => setActiveStock(s)}
      >
        {s}
      </button>

      {s === activeStock && (
        <span
          className="delete-stock"
          title="Delete Stock"
          onClick={() => deleteStock(s)}
        >
          ❌
        </span>
      )}
    </div>
  ))}
</div>


      {/* ADD STOCK */}
      <div className="row">
        <input
          placeholder="Add Stock (e.g. TCS)"
          value={newStock}
          onChange={(e) => setNewStock(e.target.value.toUpperCase())}
        />
        <button onClick={addStock}>Add Stock</button>
      </div>

      {stock && (
        <>
          <h3>📌 {activeStock}</h3>

          {/* SETTINGS */}
          <div className="row">
            <input
              type="number"
              placeholder="Brokerage %"
              value={stock.brokeragePercent}
              onChange={(e) =>
                setStocks({
                  ...stocks,
                  [activeStock]: {
                    ...stock,
                    brokeragePercent: e.target.value,
                  },
                })
              }
            />
            <input
              type="number"
              placeholder="Tax %"
              value={stock.taxPercent}
              onChange={(e) =>
                setStocks({
                  ...stocks,
                  [activeStock]: {
                    ...stock,
                    taxPercent: e.target.value,
                  },
                })
              }
            />
          </div>

          {/* CURRENT PRICE */}
          <input
            type="number"
            placeholder="Current Market Price"
            value={stock.currentPrice}
            onChange={(e) =>
              setStocks({
                ...stocks,
                [activeStock]: {
                  ...stock,
                  currentPrice: Number(e.target.value),
                },
              })
            }
          />

          {/* ADD TRADE */}
          <div className="row">
            <input
              type="number"
              placeholder="Buy Price"
              value={price}
              onChange={(e) => setPrice(e.target.value)}
            />
            <input
              type="number"
              placeholder="Quantity"
              value={qty}
              onChange={(e) => setQty(e.target.value)}
            />
            <button onClick={addTrade}>Add Buy</button>
          </div>

          <hr />

          {/* SUMMARY */}
          <div className="summary">
            <p>Total Qty: <b>{totalQty}</b></p>
            <p>Avg Buy Price: <b>₹{avgPrice.toFixed(2)}</b></p>
            <p>Total Invested: <b>₹{totalBuy.toFixed(2)}</b></p>
            <p>Gross P/L: <b>₹{grossProfit.toFixed(2)}</b></p>
            <p>Brokerage: <b>₹{brokerage.toFixed(2)}</b></p>
            <p>Tax: <b>₹{tax.toFixed(2)}</b></p>
            <p className={netProfit >= 0 ? "profit" : "loss"}>
              Net P/L: <b>₹{netProfit.toFixed(2)}</b>
            </p>
          </div>

          <hr />

          {/* TRADE LIST */}
{stock.trades.map((t, i) => {
  const isEditing = editingTradeId === t.id;

  return (
    <div key={t.id} className="trade-card">
      {isEditing ? (
        <>
          <input
            type="number"
            value={editPrice}
            onChange={(e) => setEditPrice(e.target.value)}
          />
          <input
            type="number"
            value={editQty}
            onChange={(e) => setEditQty(e.target.value)}
          />

          <button onClick={() => saveEdit(t.id)}>Save</button>
          <button onClick={cancelEdit}>Cancel</button>
        </>
      ) : (
        <>
          <p>
            Buy @ ₹{t.price} × {t.qty} =
            ₹{(t.price * t.qty).toFixed(2)}
          </p>
         <div>
             <button onClick={() => startEdit(t)}>Edit</button>
          <button onClick={() => deleteTrade(t.id)}>Delete</button>
         </div>
        
        </>
      )}
    </div>
  );
})}


        </>
      )}
    </div>
  );
}

export default App;
